module.exports = __webpack_public_path__ + "img/r1.057b2f1d.svg";